import React from 'react'
import PropTypes from 'prop-types'
import { formatPhoneNumber } from 'Utils/inputUtils'
import { getComingSoonImageUrl } from 'Components/AgentPreview'
import ImagePlaceholder from 'Components/ImagePlaceholder'
import LookupLink from 'Components/LookupLink'
import { useConfiguration } from 'Root/ConfigurationProvider'

import {
  _AgentContainer, _AgentImg, _AgentInfo, _AgentName, _AgentCard,
  _AgentPhone, _AgentPosition, _AgentBrokerageName, _BookBtn,
} from './styles'

const ContactAgentGeneric = ({ agent, handleContactAgent, mobileBrowser, gaCategory,
  googleAnalyticsEvent, requestInfo = false, cardBorder = false, whiteBackground = false, optionalGAAction = '' }) => {
  const { THEME_NAME } = useConfiguration()
  const {
    url, profile_image: img, fullname, title, cell,
    brokerage_name: brokerageName,
  } = agent || {}


  const newUrl = url && url[0] !== '/' ? '/' + url : url
  const comingSoonImg = getComingSoonImageUrl(THEME_NAME)
  const GAtracking = (source) => {
    googleAnalyticsEvent({
      category: gaCategory || 'Contact',
      action: `${optionalGAAction}[ContactCTA, ${source}, ${mobileBrowser ? 'Mobile' : 'Desktop'} ]`,
    })
  }

  return (
    <_AgentContainer requestInfo={requestInfo} cardBorder={cardBorder} >
      {(!requestInfo && agent) ? (
        <_AgentCard whiteBackground={whiteBackground}>
          <_AgentImg key={fullname}>
            <LookupLink
              to={newUrl}
              componentData={{ component: 'Agent', id: agent.id, pageData: agent }}
              onClick={() => GAtracking('AgentImg')}
            >
              <ImagePlaceholder
                src={(img && img.small_path) || ''}
                defaultSrc={comingSoonImg}
                alt={fullname}
                circle
                width={184}
                height={184}
              />
            </LookupLink>

          </_AgentImg>
          <_AgentInfo>
            <LookupLink
              to={newUrl}
              componentData={{ component: 'Agent', id: agent.id, pageData: agent }}
              onClick={() => GAtracking('Agent Name')}
            >
              <_AgentName> {fullname}</_AgentName>
            </LookupLink>
            <_AgentPosition>{title}</_AgentPosition>
            {
              brokerageName && brokerageName.includes('Property') ?
                <_AgentBrokerageName>
                  {brokerageName}
                </_AgentBrokerageName>
                : ''
            }
            <_AgentPhone>
              <a href={`tel:${cell}`} onClick={() => GAtracking('Agent Phone')}>
                {formatPhoneNumber(cell)}
              </a>
            </_AgentPhone>
          </_AgentInfo>
        </_AgentCard>
      ) : ''}
      {
        !!handleContactAgent && (
          <_BookBtn primary onClick={handleContactAgent} requestInfo={requestInfo}>
            {requestInfo ? 'Request Info' : 'Contact Agent'}
          </_BookBtn>
        )
      }

    </_AgentContainer>
  )
}

ContactAgentGeneric.propTypes = {
  agent: PropTypes.shape({
    id: PropTypes.number,
  }),
  gaCategory: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  handleContactAgent: PropTypes.func,
  mobileBrowser: PropTypes.bool,
  requestInfo: PropTypes.bool,
  cardBorder: PropTypes.bool,
  whiteBackground: PropTypes.bool,
  optionalGAAction: PropTypes.string,
}

export default ContactAgentGeneric
